/* Rhody Reviews api/v1 -- missed-call (MCTB) domain. Lane 4 (STROWGER 2026-06-18).
   $39 every 28 days Pro-only Missed-Call Text-Back. Copies the widget.ts pattern. */
import { request } from './_http';

export interface MctbSettings {
  enabled: boolean;
  text_back_template: string;
  forward_number: string | null;
  [k: string]: unknown;
}
export interface MctbResponse {
  client_id: string;
  settings: MctbSettings;
  tier: string | null;
  is_pro: boolean;
  price_per_month?: number;
  dry_run: boolean;
}
export type MctbUpdate = Partial<
  Pick<MctbSettings, 'enabled' | 'text_back_template' | 'forward_number'>
>;

export const missedCallApi = {
  getMissedCall(signal?: AbortSignal): Promise<MctbResponse> {
    return request<MctbResponse>('/api/v1/missed-call', { signal });
  },
  updateMissedCall(patch: MctbUpdate): Promise<MctbResponse> {
    return request<MctbResponse>('/api/v1/missed-call', { method: 'PUT', body: patch });
  },
};
